import {useMemo} from 'react'
import {useAppSelector} from '../../../../redux/hooks'
import {filterSelector} from '../../../../redux/slices/filterSlices'

interface RowDataProps {
  items: any[]
}

export const RowData = ({items}: RowDataProps) => {
  const {filterMaterial: filter} = useAppSelector(filterSelector)

  const rowNumber = useMemo(() => {
    const per = filter?.per_page ?? 5
    const page = filter?.page ?? 1
    return page * per - per
  }, [filter?.page, filter?.per_page])

  if (!items) return null

  return (
    <>
      {items.map((item: any, index: number) => (
        <tr key={item?.material_group ?? index}>
          <td>{index + 1 + rowNumber}</td>
          <td>{item.material_group}</td>
          <td>{item.material_number?.slice(-7)}</td>
          <td>{item.company_code}</td>
          <td>{item.plant}</td>
          <td>{item.material_description}</td>
          <td>{item.distribution_channel}</td>
          <td>{item.plant_detail?.name1}</td>
        </tr>
      ))}
    </>
  )
}
